import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bantuan-edts',
  templateUrl: './bantuan-edts.component.html',
  styleUrls: ['./bantuan-edts.component.css']
})
export class BantuanEdtsComponent implements OnInit {

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  LoaderStatus: boolean = false;
  getDate: any = new Date();
  thisYear: any = this.getDate.getFullYear();

  //UI Input Variables
  InputType: any = "";
  InputYearAssessment: any = "";

  //Value
  ListFiles:any;

  constructor() {
    this.ListFiles = {
      data: [{
        Name: "Spesifikasi Web API 2026 (e-Dts C)",
        Year: "2026"
      },
        {
        Name: "Spesifikasi Web API 2025 (e-Dts C)",
        Year: "2025"
      },
        {
        Name: "Spesifikasi Web API 2024 (e-Dts C)",
        Year: "2024"
      },
        {
        Name: "Spesifikasi Web API 2023 (e-Dts C)",
        Year: "2023"
      },
      {
        Name: "Spesifikasi Web API 2022 (e-Dts C)",
        Year: "2022"
      },
      {
        Name: "Spesifikasi Web API 2021 (e-Dts C)",
        Year: "2021"
      },
      {
        Name: "Spesifikasi Web API 2020 (e-Dts C)",
        Year: "2020"
      },
      {
        Name: "Spesifikasi Web API 2019 (e-Dts C)",
        Year: "2019"
      }]
    };
  }

  ngOnInit(): void {
  }

  View(Year: any) {
    this.LoaderStatus = true;
    if (Year === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let fileUrl = '../../../../assets/files/';
      let folderPath = "webapic/";
      let fileName = "WebAPIC" + Year + ".pdf";
      fileUrl = fileUrl + folderPath + fileName;
      window.open(fileUrl, '_blank');
      this.LoaderStatus = false;
    }
  }
  Semula() {

  }

}
